import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { buergerportalAuthHeader } from "../components/BuergerPortalGate";

const TYP_LABEL = {
  beschlussvorlage: "Beschlussvorlage", informationsvorlage: "Informationsvorlage",
  mitteilung: "Mitteilung", antrag: "Antrag", aenderungsantrag: "Änderungsantrag",
  anfrage: "Anfrage", bericht: "Bericht",
};

export default function BuergerPortalVorlage() {
  const { id } = useParams();
  const [vorlage, setVorlage] = useState(null);
  const [fehler, setFehler] = useState(false);

  useEffect(() => {
    fetch(`/api/oeffentlich/vorlagen/${id}`, { headers: buergerportalAuthHeader() })
      .then(r => {
        if (r.status === 401) { localStorage.removeItem("buergerportal_token"); window.location.reload(); return; }
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(d => d && setVorlage(d))
      .catch(() => setFehler(true));
  }, [id]);

  if (fehler) return <div style={{ padding: 40 }}>Diese Vorlage ist nicht öffentlich einsehbar.</div>;
  if (!vorlage) return <div style={{ padding: 40 }}>Wird geladen…</div>;

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <Link to="/buerger" style={{ fontSize: 13, color: "#666" }}>← Zurück zur Übersicht</Link>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginTop: 8, marginBottom: 4 }}>{vorlage.titel}</h1>
      <div style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
        {vorlage.vorlagennummer && `${vorlage.vorlagennummer} · `}{TYP_LABEL[vorlage.typ] || vorlage.typ}
      </div>

      {vorlage.kurzbeschreibung && (
        <p style={{ marginBottom: 16 }}>{vorlage.kurzbeschreibung}</p>
      )}
      {vorlage.sachverhalt && (
        <>
          <h2 style={{ fontSize: 15, fontWeight: 600, marginTop: 20, marginBottom: 6 }}>Sachverhalt</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>{vorlage.sachverhalt}</p>
        </>
      )}
      {vorlage.beschlussvorschlag && (
        <>
          <h2 style={{ fontSize: 15, fontWeight: 600, marginTop: 20, marginBottom: 6 }}>Beschlussvorschlag</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>{vorlage.beschlussvorschlag}</p>
        </>
      )}
      {vorlage.finanzielle_auswirkungen && (
        <>
          <h2 style={{ fontSize: 15, fontWeight: 600, marginTop: 20, marginBottom: 6 }}>Finanzielle Auswirkungen</h2>
          <p style={{ whiteSpace: "pre-wrap" }}>{vorlage.finanzielle_auswirkungen}</p>
        </>
      )}
    </div>
  );
}
